'use client';

import { useEffect, useState } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import LocationAutoCompleteDrawer from 'components/commercetools-ui/molecules/LocationAutoCompleteDrawer';
import { useFeatureFlagStore } from 'stores/feature-flag';
import { Locale, useLanguageStore } from 'stores/language';
import { useLocationStore } from 'stores/location';
import { useNavigationStore } from 'stores/navigation';
import { getInplAppWebviewFlag } from 'frontastic/helper/feature-flag-helper';
import { buildBreadcrumb } from 'frontastic/helper/navigation';
import useRouteChangeHandler from 'frontastic/hooks/useRouteChangeHandler';
type Props = {
  googleMapKey?: string;
};

export default function OnRoute({ googleMapKey }: Props) {
  const pathname = usePathname();
  const translate = useTranslations();
  const searchParams = useSearchParams();
  const updateLocation = useLocationStore((state) => state.updateLocation);
  const [isOpen, setIsOpen] = useState(false);
  const updateNavigation = useNavigationStore((state) => state.updateNavigation);
  const setLocale = useLanguageStore((state) => state.setLocale);
  const setInPLAppWebViewFlag = useFeatureFlagStore((state) => state.setInPLAppWebViewFlag);
  const inplappwebview = useFeatureFlagStore((state) => state.inplappwebview);
  const hydrated = useFeatureFlagStore((state) => state.hydrated);

  useRouteChangeHandler();

  // Read query params and update location
  useEffect(() => {
    const lat = searchParams.get('lat');
    const lng = searchParams.get('lng');
    const state = searchParams.get('state');

    if (lat && lng && state) {
      updateLocation({
        lat: parseFloat(lat),
        lng: parseFloat(lng),
        state: state,
        location: state,
      });
    }
  }, [searchParams, updateLocation]);

  useEffect(() => {
    if (!hydrated) return;
    const flag = getInplAppWebviewFlag();
    if (!inplappwebview) setInPLAppWebViewFlag(flag === undefined ? false : flag);
  }, [hydrated, inplappwebview, setInPLAppWebViewFlag]);

  //update breadcrumb info
  useEffect(() => {
    const breadcrumbs = buildBreadcrumb(pathname, translate);
    updateNavigation(breadcrumbs);
  }, [pathname, translate, updateNavigation]);

  //initialize locale
  useEffect(() => {
    if (!pathname) return;
    const match = pathname.match(/^\/(en|es)/);
    const current: Locale = (match?.[1] as Locale) ?? 'en';
    setLocale(current);
  }, [pathname, setLocale]);

  return <LocationAutoCompleteDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} googleMapKey={googleMapKey} />;
}
